<router-outlet />
@if (tinboHandoffActive()) {
  <div class="tinbo-handoff-overlay" aria-busy="true" aria-live="polite" aria-label="Opening Tinbo">
    <app-page-skeleton variant="mission-detail" [standalone]="true" />
  </div>
}
